import { motion } from "framer-motion";

export const HeroTourContext = () => {
  return (
    <section className="py-10 md:py-14 bg-muted">
      <div className="container-tight">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="max-w-3xl mx-auto text-center"
        >
          <span className="badge-360 mb-4">Vista360 Verified</span>
          <h2 className="font-display text-2xl sm:text-3xl font-bold text-foreground mt-3 mb-4">
            What You See Is What You Get
          </h2>
          <p className="text-muted-foreground leading-relaxed mb-6">
            Every Vista360 Verified tour is personally captured by our team in stunning 8K 360°.
            No renders, no staged photos — just an honest, immersive walkthrough of the real space.
          </p>
          <div className="bg-card border border-border rounded-2xl p-6 md:p-8 text-left">
            <p className="text-primary font-semibold text-sm uppercase tracking-wider mb-3">
              For Property Owners
            </p>
            <p className="text-foreground leading-relaxed">
              Imagine this level of immersion for your <span className="font-semibold text-secondary">₦50M–₦5B</span> listings.
              Buyers can explore every room, check finishes, and feel the space — all from their phone
              in <span className="font-semibold">London</span>, <span className="font-semibold">Dubai</span>, or <span className="font-semibold">New York</span>.
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
